import React, { useEffect, useState } from 'react';
import './upgradeMulticreatorsPane.module.scss';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { BackButtonHeader } from './BackButtonHeader';
import { Pane, PaneHeader } from '../../molecules/mypage/page';
import MultiCreatorBannerPc from './images/multicreator_banner.png';
import { CheckBox } from '@sheinc/design-system';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { SpBr } from '../../../../commonv3/components/atoms/layouts/br';

export const UpgradeMultiCreatorsPane = () => {
    const [checked, setChecked] = useState(false);

    // TODO: マルシーコースの申し込みページができたら修正
    const page_key = 'multicreator';
    const user = GlobalStatesV3.currentUser;

    useEffect(() => {
        if (user.isMultiCreatorUser()) {
            GlobalStatesV3.routing.push(V3Routes.home());
        }
    }, []);
    return (
        <Pane activeMenu="multicreator">
            {GlobalStatesV3.viewport.isMobile && <BackButtonHeader to={V3Routes.myPage()} />}
            <PaneHeader>コースのアップグレード</PaneHeader>
            <div className="pane_body">
                <a
                    id="multicreator_lp_link"
                    styleName="banner_wrapper"
                    href="https://shelikes.jp/multicreator"
                    target="_blank"
                >
                    <img styleName="banner" src={MultiCreatorBannerPc} />
                </a>

                <div styleName="description">
                    未経験でクリエイターへのキャリアチェンジを目指す女性のための、短期集中型の特別コースです。<SpBr />本コースオリジナルの実践課題と手厚いサポートで未経験からでも確実にスキル習得できるプログラムをご用意しています。
                </div>
                <div styleName="actions">
                    <CheckBox
                        id="check-confirm"
                        textSize="label"
                        checked={checked}
                        onCheck={() => setChecked(!checked)}
                    >
                        無料オンライン説明会を受けました
                    </CheckBox>
                    <div styleName="button_wrapper">
                        <Button
                            type="multicreator"
                            size="m"
                            id="multicreator_link"
                            disabled={!checked}
                            onClick={() => GlobalStatesV3.routing.push(V3Routes.applicationPageSignIn(page_key))}
                        >
                            <div styleName="button-text">入会する</div>
                            <div styleName="arrow" />
                        </Button>
                    </div>
                </div>
            </div>
        </Pane>
    );
};
